/* 修改网页标题 */
const modifyNetTitle = function (logoUlr, netTitle) {
  let logo,
    title
  if (logoUlr) {
    logo = logoUlr
  } else {
    logo = 'https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png'
  }
  if (netTitle) {
    title = netTitle
  } else {
    title = '财务数字化管理平台'
  }
  let link = `<link rel="icon" href="${logo}">`
  let tempNode = document.createElement("div")
  tempNode.innerHTML = link
  document.querySelector("head").append(tempNode.firstChild)
  document.querySelector('title').innerHTML = title
}

/* 时间戳转化为年月日 */
function formatTimeToDate(time) {
  let date
  if (time) {
    date = new Date(time)
  } else {
    date = new Date()
  }
  let year = date.getFullYear()
  let month = date.getMonth() + 1
  month = month > 9 ? month : '0' + month
  let detailDate = date.getDate()
  detailDate = detailDate > 9 ? detailDate : '0' + detailDate
  return `${year}-${month}-${detailDate}`
}

/* 时间戳转化为年月日时分 */
function formaTimeToMinute(time) {
  let date
  if (time) {
    date = new Date(time)
  } else {
    date = new Date()
  }
  let year = date.getFullYear()
  let month = date.getMonth() + 1
  month = month > 9 ? month : '0' + month
  let detailDate = date.getDate()
  detailDate = detailDate > 9 ? detailDate : '0' + detailDate
  let hour = date.getHours()
  hour = hour > 9 ? hour : '0' + hour
  let minute = date.getMinutes()
  minute = minute > 9 ? minute : '0' + minute
  return `${year}-${month}-${detailDate} ${hour}:${minute}`
}

/* 时间戳转化为年月日时分秒 */
function formaTimeToSecond(time) {
  let date = new Date(time)
  let year = date.getFullYear()
  let month = date.getMonth() + 1
  month = month > 9 ? month : '0' + month
  let detailDate = date.getDate()
  detailDate = detailDate > 9 ? detailDate : '0' + detailDate
  let hour = date.getHours()
  hour = hour > 9 ? hour : '0' + hour
  let minute = date.getMinutes()
  minute = minute > 9 ? minute : '0' + minute
  let second = date.getSeconds()
  second = second > 9 ? second : '0' + second
  return `${year}-${month}-${detailDate}  ${hour}:${minute}:${second}`
}

/* url拼接字符串 */
function handleGetRequestParams(params) {
  let url = ''
  for (let key in params) {
    let value = (params[key] !== undefined && params[key] !== null) ? params[key] : '';
    url += `&${key}=${encodeURIComponent(value)}`
  }
  return url.substring(1)
}

function formatTimeMonthToDate(time) {
  let date
  if (time) {
    date = new Date(time)
  } else {
    date = new Date()
  }
  let month = date.getMonth() + 1
  month = month > 9 ? month : '0' + month
  let detailDate = date.getDate()
  detailDate = detailDate > 9 ? detailDate : '0' + detailDate
  return `${month}-${detailDate}`
}

/* 计算天数 */
function calculationDays(start, end) {
  if (start && end) {
    let endTime = new Date(end).getTime() / 1000 - parseInt(new Date(start).getTime() / 1000);
    let timeDay = parseInt(endTime / 60 / 60 / 24);  // 相差天数
    return timeDay + 1
  }
}

let avater = require("../../assets/avater.png")
/* 遍历child */
function mapChild(child, id) {
  let arr = [];
  child.map((value) => {
    let obj = {};
    if (value.zzdCode) {
      obj.id = `${value.zzdCode}|${value.deptId}`
    } else {
      obj.id = value.id;
    }
    obj.id2 = value.id
    obj.teamId = id
    obj.zzdCode = value.zzdCode
    obj.departmentName = value.name;
    obj.image = value.image;
    obj.level = value.level;
    obj.parentId = value.parentId;
    obj.parentName = value.parentName;
    obj.departmentNum = value.totalNum;
    obj.departmentHead = value.head;
    obj.jurisdictionHead = value.leader;
    obj.departmentHeadImg = value.headImage
      ? value.headImage
      : avater;
    obj.jurisdictionHeadImg = value.leaderImage
      ? value.leaderImage
      : avater;
    if (value.subList && value.subList.length > 0) {
      obj.subList = mapChild(value.subList, value.parentId);
    } else {
      obj.subList = [];
    }
    if (value.memberList && value.memberList.length > 0) {
      obj.subList = mapChild(value.memberList);
    }
    arr.push(obj);
  });
  return arr;
}

function mapChild2(child, id) {
  let arr = [];
  child.map((value) => {
    let obj = {};
    if (value.zzdCode) {
      obj.id = `${value.zzdCode}|${value.deptId}`
    } else {
      obj.id = value.id;
    }
    obj.id2 = value.id
    obj.teamId = id
    obj.zzdCode = value.zzdCode
    obj.departmentName = value.name;
    obj.image = value.image;
    obj.level = value.level;
    obj.parentId = value.parentId;
    obj.parentName = value.parentName;
    obj.departmentNum = value.totalNum;
    obj.departmentHead = value.head;
    obj.jurisdictionHead = value.leader;
    obj.departmentHeadImg = value.headImage
      ? value.headImage
      : avater;
    obj.jurisdictionHeadImg = value.leaderImage
      ? value.leaderImage
      : avater;
    if (value.subList && value.subList.length > 0) {
      obj.subList = mapChild2(value.subList, value.parentId);
    } else {
      obj.subList = [];
    }
    arr.push(obj);
  });
  return arr;
}

/* 遍历child, 当三级下面没有四级部门时，不可被选择 */
function mapChildDisable(child, id) {
  let arr = [];
  child.map((value) => {
    let obj = {};
    if (value.zzdCode) {
      obj.id = `${value.zzdCode}|${value.deptId}`
    } else {
      obj.id = value.id;
    }
    obj.id2 = value.id
    obj.teamId = id
    obj.zzdCode = value.zzdCode
    obj.departmentName = value.name;
    obj.image = value.image;
    obj.level = value.level;
    obj.parentId = value.parentId;
    obj.parentName = value.parentName;
    obj.departmentNum = value.totalNum;
    obj.departmentHead = value.head;
    obj.jurisdictionHead = value.leader;
    obj.departmentHeadImg = value.headImage
      ? value.headImage
      : avater;
    obj.jurisdictionHeadImg = value.leaderImage
      ? value.leaderImage
      : avater;
    obj.disabled = false
    if (value.subList && value.subList.length > 0) {
      obj.subList = mapChildDisable(value.subList, value.parentId);
    } else {
      if (value.level != 4) {
        obj.disabled = true
      }
      obj.subList = [];
    }
    if (value.memberList && value.memberList.length > 0) {
      obj.subList = mapChildDisable(value.memberList);
    }
    arr.push(obj);
  });
  return arr;
}

/* 遍历child, 只能选择2级部门 */
function mapChildSecondDisable(child, id) {
  let arr = [];
  child.map((value) => {
    if (value.level < 3) {
      let obj = {};
      if (value.zzdCode) {
        obj.id = `${value.zzdCode}|${value.deptId}`
      } else {
        obj.id = value.id;
      }
      obj.id2 = value.id
      obj.teamId = id
      obj.zzdCode = value.zzdCode
      obj.departmentName = value.name;
      obj.image = value.image;
      obj.level = value.level;
      obj.parentId = value.parentId;
      obj.parentName = value.parentName;
      obj.departmentNum = value.totalNum;
      obj.departmentHead = value.head;
      obj.jurisdictionHead = value.leader;
      obj.departmentHeadImg = value.headImage
        ? value.headImage
        : avater;
      obj.jurisdictionHeadImg = value.leaderImage
        ? value.leaderImage
        : avater;
      if (value.level < 2) {
        obj.disabled = true
      } else {
        obj.disabled = false
      }
      if (value.subList && value.subList.length > 0) {
        obj.subList = mapChildSecondDisable(value.subList, value.parentId);
      } else {
        obj.subList = [];
      }
      arr.push(obj);
    }
  });
  return arr;
}

/* 遍历child, 只能选择3级部门 */
function mapChildThirdDisable(child, id) {
  let arr = [];
  child.map((value) => {
    if (value.level < 4) {
      let obj = {};
      if (value.zzdCode) {
        obj.id = `${value.zzdCode}|${value.deptId}`
      } else {
        obj.id = value.id;
      }
      obj.id2 = value.id
      obj.teamId = id
      obj.zzdCode = value.zzdCode
      obj.departmentName = value.name;
      obj.image = value.image;
      obj.level = value.level;
      obj.parentId = value.parentId;
      obj.parentName = value.parentName;
      obj.departmentNum = value.totalNum;
      obj.departmentHead = value.head;
      obj.jurisdictionHead = value.leader;
      obj.departmentHeadImg = value.headImage
        ? value.headImage
        : avater;
      obj.jurisdictionHeadImg = value.leaderImage
        ? value.leaderImage
        : avater;
      if (value.level < 3) {
        obj.disabled = true
      } else {
        obj.disabled = false
      }
      if (value.subList && value.subList.length > 0) {
        obj.subList = mapChildThirdDisable(value.subList, value.parentId);
      } else {
        obj.subList = [];
      }
      arr.push(obj);
    }
  });
  return arr;
}

/* 遍历child, 只能选择4级部门 */
function mapChildFourDisable(child, id) {
  let arr = [];
  child.map((value) => {
      let obj = {};
      if (value.zzdCode) {
        obj.id = `${value.zzdCode}|${value.deptId}`
      } else {
        obj.id = value.id;
      }
      obj.id2 = value.id
      obj.teamId = id
      obj.zzdCode = value.zzdCode
      obj.departmentName = value.name;
      obj.image = value.image;
      obj.level = value.level;
      obj.parentId = value.parentId;
      obj.parentName = value.parentName;
      obj.departmentNum = value.totalNum;
      obj.departmentHead = value.head;
      obj.jurisdictionHead = value.leader;
      obj.departmentHeadImg = value.headImage
        ? value.headImage
        : avater;
      obj.jurisdictionHeadImg = value.leaderImage
        ? value.leaderImage
        : avater;
      if (value.level < 4) {
        obj.disabled = true
      } else {
        obj.disabled = false
      }
      if (value.subList && value.subList.length > 0) {
        obj.subList = mapChildFourDisable(value.subList, value.parentId);
      } else {
        obj.subList = [];
      }
      arr.push(obj);
  });
  return arr;
}

/* 遍历child, 当子级没有时，不可被选择 */
function mapChildChildrenNoDisable(child, id) {
  let arr = [];
  child.map((value) => {
    let obj = {};
    if (value.zzdCode) {
      obj.id = `${value.zzdCode}|${value.deptId}`
    } else {
      obj.id = value.id;
    }
    obj.id2 = value.id
    obj.teamId = id
    obj.zzdCode = value.zzdCode
    obj.departmentName = value.name;
    obj.image = value.image;
    obj.level = value.level;
    obj.parentId = value.parentId;
    obj.parentName = value.parentName;
    obj.departmentNum = value.totalNum;
    obj.departmentHead = value.head;
    obj.jurisdictionHead = value.leader;
    obj.departmentHeadImg = value.headImage
      ? value.headImage
      : avater;
    obj.jurisdictionHeadImg = value.leaderImage
      ? value.leaderImage
      : avater;
    obj.disabled = false
    if (value.subList && value.subList.length > 0) {
      obj.subList = mapChildChildrenNoDisable(value.subList, value.parentId);
    } else {
      if (value.level && (!value.memberList || value.memberList.length == 0)) {
        obj.disabled = true
      }
      obj.subList = [];
    }
    if (value.memberList && value.memberList.length > 0) {
      obj.subList = mapChildChildrenNoDisable(value.memberList);
    }
    arr.push(obj);
  });
  return arr;
}


let threeSpotImg = require('../../assets/tree/three-spot.png')
let threeSpotHighImg = require('../../assets/tree/three-spot-high.png')
let bookImg = require('../../assets/tree/book.png')
let randomImg = require('../../assets/tree/random.png')
let carImg = require('../../assets/tree/car.png')
let aircraftImg = require('../../assets/tree/aircraft.png')
let bookingImg = require('../../assets/tree/booking.png')
function mapId(child, id) {
  let arr = []
  child.map(i => {
    if (i.id === id) {
      i.threeSpotImg = threeSpotHighImg
    } else {
      i.threeSpotImg = threeSpotImg
    }

    if (i.children && i.children.length > 0) {
      i.img = bookImg
      mapId(i.children, id);
    } else {
      if (i.label === '车，船票') {
        i.img = carImg
      } else if (i.label === '飞机票') {
        i.img = aircraftImg
      } else if (i.label === '订，退票费') {
        i.img = bookingImg
      } else {
        i.img = randomImg
      }
    }
    arr.push(i)
  })
  return arr
}

/* 用于报销单分类 */
function mapId4(child, id) {
  let arr = []
  child.map(i => {
    if (i.id === id) {
      i.threeSpotImg = threeSpotHighImg
    } else {
      i.threeSpotImg = threeSpotImg
    }
    if (i.level == 1) {
      i.img = bookImg
      mapId4(i.children, id);
    } else {
      i.img = randomImg
    }
    arr.push(i)
  })
  return arr
}

/* 用于预审批单分类 */
function mapId5(child, id) {
  let arr = []
  child.map(i => {
    if (i.id === id) {
      i.threeSpotImg = threeSpotHighImg
    } else {
      i.threeSpotImg = threeSpotImg
    }
    if (i.level == 1 || i.level == 2) {
      i.img = bookImg
      mapId5(i.children, id);
    } else {
      i.img = randomImg
    }
    arr.push(i)
  })
  return arr
}

function mapId3(child, id) {
  let arr = []
  child.map(i => {
    if (i.id === id) {
      i.threeSpotImg = threeSpotHighImg
    } else {
      i.threeSpotImg = threeSpotImg
    }

    if (i.subList && i.subList.length > 0) {
      i.img = bookImg
      mapId3(i.subList, id);
    } else {
      if (i.label === '车，船票') {
        i.img = carImg
      } else if (i.label === '飞机票') {
        i.img = aircraftImg
      } else if (i.label === '订，退票费') {
        i.img = bookingImg
      } else {
        i.img = randomImg
      }
    }
    arr.push(i)
  })
  return arr
}

function mapId2(child, id) {
  let arr = []
  child.map(i => {
    if (i.id === id) {
      if (i.level === 1) {
        i.img = require('../../assets/tree/first-high.png')
      } else {
        i.img = require('../../assets/tree/second-high.png')
      }
      i.threeSpotImg = require('../../assets/tree/three-spot-high.png')
    } else {
      if (i.level === 1) {
        i.img = require('../../assets/tree/first.png')
      } else {
        i.img = require('../../assets/tree/second.png')
      }
      i.threeSpotImg = require('../../assets/tree/three-spot.png')
    }
    if (i.subList && i.subList.length > 0) {
      mapId2(i.subList, id);
    }
    arr.push(i)
  })
  return arr
}


/* 判断鼠标是否落在一个块级元素内部obj是被拖拽的元素 */
function checkIn(obj, clientX, clientY) {
  let x = clientX ? Number(clientX) : Number(window.event.clientX) // 鼠标相对屏幕横坐标
  let y = clientY ? Number(clientY) : Number(window.event.clientY) // 鼠标相对屏幕纵坐标

  let div_x = Number(obj.getBoundingClientRect().left) // obj相对屏幕的横坐标
  let div_x_width = Number(
    obj.getBoundingClientRect().left + obj.clientWidth
  ) // obj相对屏幕的横坐标+width

  let div_y = Number(obj.getBoundingClientRect().top) // obj相对屏幕的纵坐标
  let div_y_height = Number(
    obj.getBoundingClientRect().top + obj.clientHeight
  ) // obj相对屏幕的纵坐标+height

  if (x > div_x && x < div_x_width && y > div_y && y < div_y_height) {
    return true
  } else {
    return false
  }
}

/* 随机生成n位字符串 */
let str = [
  '0', '1', '2', '3', '4', '5', '6', '7', '8', '9',
 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 
 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z',
  , 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k',
  'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z'
];
function generateMixed(n) {
  let res = "";
  for (let i = 0; i < n; i++) {
    let id = Math.ceil(Math.random() * 35);
    res += str[id];
  }
  return res;
}

/* 
  金额处理，上传参数*100， 获取参数 /100
  num: 是金额
  type: 1是传参; 2是获取参数
 */
function handleAmount(num, type) {
  let amount = Number(num)
  if (type == 1) {
    let amountCopy = Number((amount * 100))
    return keepTwoDecimal(amountCopy)
  } else {
    let amountCopy = Number((amount / 100))
    return keepTwoDecimal(amountCopy)
  }
}

/* 四舍五入保留2位小数（若第二位小数为0，则保留一位小数） */
function keepTwoDecimal(num) {
  let result = parseFloat(num);
  if (isNaN(result)) {
    alert('传递参数错误，请检查！');
    return false;
  }
  result = Math.round(num * 100) / 100;
  return result;
}

/*
  获取上周、本周、下周的时间
  //上周的开始时间
  console.log(getTime(7));
  //上周的结束时间
  console.log(getTime(1));
  //本周的开始时间
  console.log(getTime(0));
  //本周的结束时间
  console.log(getTime(-6));
  //下周的开始时间
  console.log(getTime(-7));
  //下周结束时间
  console.log(getTime(-13));
 */
function getWeekDay(n) {
  var now = new Date();
  var year = now.getFullYear();
  //因为月份是从0开始的,所以获取这个月的月份数要加1才行
  var month = now.getMonth() + 1;
  var date = now.getDate();
  var day = now.getDay();
  //判断是否为周日,如果不是的话,就让今天的day-1(例如星期二就是2-1)
  if (day !== 0) {
    n = n + (day - 1);
  } else {
    n = n + day;
  }
  if (day) {
    //这个判断是为了解决跨年的问题
    if (month > 1) {
      month = month;
    }
    //这个判断是为了解决跨年的问题,月份是从0开始的
    else {
      year = year - 1;
      month = 12;
    }
  }
  now.setDate(now.getDate() - n);
  year = now.getFullYear();
  month = now.getMonth() + 1;
  date = now.getDate();
  var s = year + "-" + (month < 10 ? ('0' + month) : month) + "-" + (date < 10 ? ('0' + date) : date);
  return s;
}

/* 
  数组去重
  has方法可以判断Map对象中是否存在指定元素,有则返回true，否则返回false
  set方法可以向Map对象添加新元素 map.set(key, value)
  values方法可以返回Map对象值的遍历器对象
 */
function unique(arr) {
  let res = []
  let map = new Map()
  for (let i of arr) {
    if (!map.has(i.id)) {
      map.set(i.id, i)
    }
  }
  res = [...map.values()]
  return res
}

/* 限制数量为正整数 */
function inputNums(val) {
  let num = 0
  let quantity = val.toString().match(/^(\+)?\d*/g)
    ? val === "00"
      ? "0"
      : val.toString().match(/^(\+)?\d*/g)[0]
    : "";
  num = Number(quantity);
  return num
}

/* 限制金额为2位小数(正整数) */
function inputTwoDecimal(val) {
  let price = val.toString().match(/^\d*(\.?\d{0,2})/g)
    ? val === "00"
      ? "0"
      : val.toString().match(/^\d*(\.?\d{0,2})/g)[0]
    : "";
  return price;
}
/* 限制金额为2位小数（包含负数） */
function inputAllTwoDecimal(val) {
  let price = val.toString().match(/^(\-|\+)?\d*(\.?\d{0,2})/g)
    ? val === "00"
      ? "0"
      : val.toString().match(/^(\-|\+)?\d*(\.?\d{0,2})/g)[0]
    : "";
  return price;
}

/* 树结构筛选 */
function treeFilter(tree, func) {
  // 使用map复制一下节点，避免修改到原树
  return tree.map(node => ({ ...node })).filter(node => {
    node.subList = node.subList && treeFilter(node.subList, func)
    return func(node) || (node.subList && node.subList.length)
  })
}

/* 树结构节点路径筛选 */
function treeFind(tree, func) {
  for (const data of tree) {
    if (func(data)) return data
    if (data.subList) {
      const res = treeFind(data.subList, func)
      if (res) return res
    }
  }
  return null
}

/* 树结构所有对象筛选 */
function treeFindPath(tree, func, path = []) {
  if (!tree) return []
  for (const data of tree) {
    path.push(data)
    if (func(data)) return path
    if (data.subList) {
      const findChildren = treeFindPath(data.subList, func, path)
      if (findChildren.length) return findChildren
    }
    path.pop()
  }
  return []
}

/* 判读是否有重复项 */
function isRepeat(arr) {
  const newArr = arr.map(item => item.nums.toString())
  const arrSet = new Set(newArr)
  return (newArr.length === arrSet.size)
}

/* 获得字符串实际长度，中文2，英文1  */
function strLen(str) {
  let realLength = 0, len = str.length, charCode = -1;
  for (let i = 0; i < len; i++) {
    charCode = str.charCodeAt(i);
    if (charCode >= 0 && charCode <= 128) realLength += 1;
    else realLength += 2;
  }
  return realLength;
}

/* 防抖 */
function debounce(fn, delay) {
  let timer = null
  return function () {
    if (timer) {
      clearTimeout(timer)
      console.log('拦截')
    }
    timer = setTimeout(() => {
      console.log('发送')

      fn.apply(this, arguments)
      timer = null
    }, delay)
  }
}

export {
  modifyNetTitle,
  formatTimeToDate,
  formaTimeToMinute,
  formaTimeToSecond,
  handleGetRequestParams,
  mapChild,
  mapChild2,
  mapChildDisable,
  mapChildSecondDisable,
  mapChildThirdDisable,
  mapChildChildrenNoDisable,
  mapChildFourDisable,
  mapId,
  mapId2,
  mapId3,
  mapId4,
  checkIn,
  generateMixed,
  handleAmount,
  keepTwoDecimal,
  mapId5,
  getWeekDay,
  unique,
  inputNums,
  inputTwoDecimal,
  inputAllTwoDecimal,
  treeFilter,
  treeFind,
  formatTimeMonthToDate,
  calculationDays,
  treeFindPath,
  isRepeat,
  strLen,
  debounce
}